import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import styles from "../../styles/Home.module.css";
import Footer from "./Footer";
import Header from "./Header";
import axios from 'axios';
import useToken from '../auth/useToken';

const useStyles = makeStyles((theme) => ({
  main: {
    backgroundColor: theme.palette.background.default,
    // display: "flex",
    // flex: 1,
    backgroundColor: '#FFFFFF',
    backgroundSize: "100% calc(100vw * 1 / 4)",
    minHeight: '85.8vh'
  },
  container: {
    // paddingLeft: 0,
    // paddingRight: 0,
  },
}));



export default function Layout({ children, title = 'asd' }) {
  const classes = useStyles();

  const {token, setToken } = useToken();

  return (
    <div className="container-fluid p-0">
      <Header  />
      <main className={classes.main}>

        {children}


      </main>
      <Footer />
    </div>
  );
}
